import React from 'react';
import { render } from 'react-dom';
import Modal from 'react-modal';

import { App } from 'containers';
import { makeServer } from './mock-server';

import 'theme/index.css';

if (process.env.REACT_APP_USE_MOCKS) {
  makeServer({ environment: 'test' });
}

const rootEl = document.getElementById('root');
render(<App />, rootEl);

Modal.setAppElement(rootEl!);
